import axios from 'axios'

export default {
  namespaced: true,

  state: {
    supplierList: [],
    total: 0,
    current: undefined,
    editId: undefined,
    editSupplier: null
  },

  mutations: {
    add (state) {
      if (!state.supplierList[0] || state.supplierList[0].id) {
        state.editId = undefined
        state.editSupplier = { status: 1 }
        state.supplierList.unshift({})
      }
    },

    cancelAdd (state) {
      state.editSupplier = null
      state.supplierList.shift()
    },

    edit (state, { supplier }) {
      state.editId = supplier.id
      let newSupplier = { ...supplier }
      delete newSupplier._index
      delete newSupplier._rowKey
      state.editSupplier = newSupplier
      if (!state.supplierList[0].id) {
        state.supplierList.shift()
      }
    },

    cancelEdit (state) {
      state.editId = undefined
      state.editSupplier = null
    },

    replace (state, { supplier }) {
      const index = state.supplierList.findIndex(item => !item.id || item.id === supplier.id)
      state.supplierList.splice(index, 1, supplier)
    },

    setList (state, { supplierList, total, current }) {
      state.supplierList = supplierList
      state.total = total
      state.current = current
    },

    remove (state, { id }) {
      const index = state.supplierList.findIndex(item => item.id === id)
      state.supplierList.splice(index, 1)
    }
  },

  actions: {
    getAll ({ commit }) {
      return axios.get('/supplier').then(result => {
        commit('setList', {
          supplierList: [...result.data],
          total: result.data.length,
          current: 1
        })
      })
    },

    submitAdd ({ state, commit, dispatch }) {
      axios.post(`/supplier`, { supplier: state.editSupplier }).then(result => {
        if (result !== -1) {
          commit('replace', { supplier: result.data })
          this._vm.$Message.success('添加广告位成功')
          commit('cancelEdit')
          dispatch('getAll')
        }
      })
    },

    submitEdit ({ state, commit, dispatch }) {
      axios.put(`/supplier/${state.editSupplier.id}`, { supplier: state.editSupplier }).then(result => {
        if (result !== -1) {
          commit('replace', { supplier: result.data })
          this._vm.$Message.success('更新广告位成功')
          commit('cancelEdit')
          dispatch('getAll')
        }
      })
    },

    delete ({ commit, dispatch }, { supplier }) {
      axios.delete(`/supplier/${supplier.id}`).then(result => {
        commit('remove', { id: supplier.id })
        this._vm.$Message.success(result.data)
        commit('cancelEdit')
        dispatch('getAll')
      })
    }
  }
}
